import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-baggage-delay-support-doc',
    templateUrl: './baggage-delay-support-doc.component.html',
    styleUrls: ['./baggage-delay-support-doc.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class BaggageDelaySupportDocComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
